import { ReactNode } from "react";
import { styles } from "./ComponentFrame.style";
import { LinkButton } from "../../elements/LinkButton";
import { ButtonVariants } from "../../shared/Button";

export interface ComponentFrameProps {
  title: string;
  buttonText?: string;
  linkTo?: string;
  testId?: string;
  hasAutoHeight?: boolean;
  hasBottomSpace?: boolean;
  smallMarginTop?: boolean;
  children?: ReactNode;
}

export const ComponentFrame = (props: ComponentFrameProps) => {
  const {
    title,
    buttonText,
    linkTo,
    testId,
    children,
    hasAutoHeight = false,
    hasBottomSpace = true,
    smallMarginTop = false,
  } = props;
  return (
    <div className={styles.container(hasAutoHeight)}>
      <h5 className={styles.heading()}>{title}</h5>
      <div className={styles.childrenWrapper(hasBottomSpace, smallMarginTop)}>{children}</div>
      {buttonText && linkTo && (
        <LinkButton
          variant={ButtonVariants.TextDecorated}
          className={styles.button()}
          href={linkTo}
          testSelector={testId}
        >
          {buttonText}
        </LinkButton>
      )}
    </div>
  );
};
